export const SET_TICKETS = "setTickets";
export const SET_FILTER = "setFilter";
export const SET_MEISTERBEREICHFILTER = "setMeisterbereichFilter";
export const SET_VERKEHRSMEISTERFILTER = "setVerkehrsmeisterFilter";
